import { requestAnalysis } from './analysisRequest';

/**
 * Render an svgson JSON tree to a base64 PNG for AI analysis.
 * Returns a plain base64 string (no data-url prefix).
 */
export const svgToBase64Png = (svgJson, { width = 1024, height = 1024 } = {}) => {
  return new Promise((resolve, reject) => {
    const { stringify } = require("svgson");
    const svgStr = stringify(svgJson);
    const blob = new Blob([svgStr], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const aspect = img.naturalWidth / img.naturalHeight;
      if (aspect > 1) {
        canvas.width = width;
        canvas.height = Math.round(width / aspect);
      } else {
        canvas.height = height;
        canvas.width = Math.round(height * aspect);
      }
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      const dataUrl = canvas.toDataURL("image/png", 0.9);
      resolve(dataUrl.replace(/^data:image\/png;base64,/, ""));
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to render SVG to image"));
    };
    img.src = url;
  });
};

/**
 * Call the stitch analysis Cloud Function.
 *
 * @param {string} base64Image  Plain base64 PNG string
 * @param {number} layerCount   Number of color layers
 * @param {string[]} colors     Hex color strings per layer
 * @returns {Promise<object>}   { layers: [...], global: {...} }
 */
export const analyzeStitchSettings = async (base64Image, layerCount, colors, { targetWidthMm, targetHeightMm, fabricType } = {}) => {
  const response = await requestAnalysis(
    'analyzeStitchSettings',
    { base64Image, layerCount, colors, targetWidthMm, targetHeightMm, fabricType },
    60000
  );

  if (!response.data?.success) {
    throw new Error(response.data?.error || "Analysis failed");
  }

  return response.data.settings;
};
